import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import {
  LIST_SP_TAB_HISTORY,
  LIST_SP_TAB_PROGRESS,
  LIST_SP_TAB_SUMMARY,
} from '../constant';

import CertsListSidePanelBodyError from './CertsListSidePanelBodyError';
import CertsListSidePanelBodyHistory from './CertsListSidePanelBodyHistory';
import CertsListSidePanelBodyProgress from './CertsListSidePanelBodyProgress';
import CertsListSidePanelBodySummary from './CertsListSidePanelBodySummary';

function CertsListSidePanelBodyContent({
  tab,
  sidePanelData,
  retriggerApisForError,
  handleCloseSidePanel,
  activeTab,
  setActiveTab,
}) {
  const {
    global: { globalDateFormat },
    core: { isAdminLogin },
  } = useSelector((state) => state?.certifications?.list);

  const isSummaryTabErrored =
    sidePanelData.networkFailedTabs.includes(LIST_SP_TAB_SUMMARY);
  const isHistoryTabErrored =
    sidePanelData.networkFailedTabs.includes(LIST_SP_TAB_HISTORY);
  const isProgressTabErrored =
    sidePanelData.networkFailedTabs.includes(LIST_SP_TAB_PROGRESS);

  const renderTabContent = () => {
    const isError = Boolean(
      (isSummaryTabErrored && tab === LIST_SP_TAB_SUMMARY) ||
        (isHistoryTabErrored && tab === LIST_SP_TAB_HISTORY) ||
        (isProgressTabErrored && tab === LIST_SP_TAB_PROGRESS)
    );

    if (isError) {
      return (
        <CertsListSidePanelBodyError
          tab={tab}
          retriggerApisForError={retriggerApisForError}
          handleCloseSidePanel={handleCloseSidePanel}
        />
      );
    }

    if (tab === LIST_SP_TAB_SUMMARY) {
      return (
        <CertsListSidePanelBodySummary
          setActiveTab={setActiveTab}
          summaryData={sidePanelData[LIST_SP_TAB_SUMMARY]}
          historyData={sidePanelData[LIST_SP_TAB_HISTORY]}
          isAdminLogin={isAdminLogin}
          globalDateFormat={globalDateFormat}
          isPrimaryCertifierActive={
            sidePanelData?.sidePanelMetaData?.isPrimaryCertifierActive
          }
          isAutoRevoke={sidePanelData?.sidePanelMetaData?.autoRevoke}
        />
      );
    }

    if (tab === LIST_SP_TAB_HISTORY) {
      return (
        <CertsListSidePanelBodyHistory
          activeTab={activeTab}
          historyData={sidePanelData[LIST_SP_TAB_HISTORY]}
          handleCloseSidePanel={handleCloseSidePanel}
        />
      );
    }

    if (tab === LIST_SP_TAB_PROGRESS) {
      return (
        <CertsListSidePanelBodyProgress
          progressData={sidePanelData[LIST_SP_TAB_PROGRESS]}
          campaignType={sidePanelData?.sidePanelMetaData?.campaignType}
        />
      );
    }

    return null;
  };

  return (
    <Box tag='div' className='CertsListSidePanelBody-tabContentWrapper'>
      {renderTabContent()}
    </Box>
  );
}

CertsListSidePanelBodyContent.propTypes = {
  tab: PropTypes.string.isRequired,
  sidePanelData: PropTypes.shape({
    networkFailedTabs: PropTypes.arrayOf(PropTypes.string),
    sidePanelMetaData: PropTypes.shape({
      autoRevoke: PropTypes.bool,
      progress: PropTypes.string,
      isPrimaryCertifierActive: PropTypes.bool,
    }),
  }).isRequired,
  retriggerApisForError: PropTypes.func,
  handleCloseSidePanel: PropTypes.func,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
};

CertsListSidePanelBodyContent.defaultProps = {
  retriggerApisForError: () => {},
  handleCloseSidePanel: () => {},
  activeTab: '',
  setActiveTab: () => {},
};

export default CertsListSidePanelBodyContent;
